import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { ROUTES } from "@/config/constants";
import { useAppAccess } from "@/hooks/useAppAccess";

export function AdminRoute({ children }: { children: ReactNode }) {
  const { isAdmin } = useAppAccess();
  if (!isAdmin) {
    return <Navigate to={ROUTES.HOME} replace />;
  }
  return <>{children}</>;
}
